import React, {useEffect, useState} from 'react';
import CorporatePageTable from './corporatePageTable';

const Corporates = (props) => {

  return (
      <CorporatePageTable></CorporatePageTable>
  );
}

export default Corporates;
